'use strict'

var drain = require('./drain')

module.exports = function onEnd (done) {
  return drain(null, done)
}



//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sinks/on-end.js
// module id = 776
// module chunks = 0